import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={30}
      height={30}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.313 1.5v9.25c0 .813-.688 1.5-1.5 1.5H7.875L2 15.312V12.25h-.5a1.52 1.52 0 01-1.5-1.5V1.5C0 .687.687 0 1.5 0h14.375c.812 0 1.438.687 1.438 1.5z"
        fill="#F3705A"
      />
      <path
        d="M4.062 7.75a1.625 1.625 0 100-3.25 1.625 1.625 0 000 3.25zM8.687 7.75a1.625 1.625 0 100-3.25 1.625 1.625 0 000 3.25zM13.313 7.75a1.625 1.625 0 100-3.25 1.625 1.625 0 000 3.25z"
        fill="#fff"
      />
      <path
        d="M12.688 5.187v9.188c0 .813.687 1.5 1.5 1.5h8l5.874 3.063v-3.063h.438c.813 0 1.5-.688 1.5-1.5V5.187c0-.812-.688-1.5-1.5-1.5H14.125c-.813 0-1.438.688-1.438 1.5z"
        fill="#FFD15C"
      />
      <path
        d="M25.938 11.437a1.625 1.625 0 100-3.25 1.625 1.625 0 000 3.25zM21.313 11.437a1.625 1.625 0 100-3.25 1.625 1.625 0 000 3.25zM16.688 11.438a1.625 1.625 0 100-3.25 1.625 1.625 0 000 3.25z"
        fill="#fff"
      />
      <path
        d="M21.75 16.25v9.25c0 .813-.688 1.5-1.5 1.5h-4.938l-2.25 3-2.25-3.063H5.938a1.52 1.52 0 01-1.5-1.5V16.25c0-.813.688-1.5 1.5-1.5h14.375c.813 0 1.438.688 1.438 1.5z"
        fill="#66C6B9"
      />
      <path
        d="M17.688 22.5a1.625 1.625 0 100-3.25 1.625 1.625 0 000 3.25zM13.125 22.5a1.625 1.625 0 100-3.25 1.625 1.625 0 000 3.25zM8.5 22.5a1.625 1.625 0 100-3.25 1.625 1.625 0 000 3.25z"
        fill="#fff"
      />
    </svg>
  )
}

export default SvgComponent
